import { cn } from '@dfh-corp-sites/ui/utils'
import { graphql } from 'gatsby'
import { XIcon } from 'lucide-react'
import React, { useState } from 'react'

import { SanityTopBanner } from '../../graphql/gatsby'
import SanityLink from '../global/SanityLink'

export type TopBannerProps = Pick<SanityTopBanner, 'text' | 'cta'> & {
  className?: string
}

const TopBanner: React.FC<TopBannerProps> = ({ text, cta, className }) => {
  const [show, setShow] = useState(true)
  if (!show) return null
  return (
    <aside
      className={cn(
        'text-center py-3 bg-brand-navy-3 flex items-center justify-center relative px-6 xl:px-12',
        className,
      )}
    >
      <div className="flex justify-center items-center gap-7">
        <span>{text}</span>

        {cta?.link && (
          <SanityLink className="font-bold underline" to={cta?.link}>
            {cta?.title}
          </SanityLink>
        )}
      </div>

      <button
        onClick={() => setShow(false)}
        className="absolute top-0 bottom-0 right-6 xl:right-12"
      >
        <XIcon className="w-6 h-6" />
      </button>
    </aside>
  )
}

export const pdpTopBanner = graphql`
  fragment pdpTopBanner on SanitySiteSettings {
    pdpTopBanner {
      title
      text
      cta {
        _type
        title
        link {
          ...LinkFragment
        }
      }
    }
  }
`

export default TopBanner
